export default __webpack_public_path__ + "static/media/ThankYou.6ee3ea39.svg";